// 生产构建时由 scripts/build.js 注入；开发环境读取本地构建号。
export const FRONTEND_VERSION =
  process.env.VUE_APP_FRONTEND_VERSION || "1.0.0";
